module.exports = __webpack_public_path__ + "static/media/nv.4fe73834.svg";